export default "__VITE_ASSET__tEsaJB5T__"